<template>
    <div class="org-tree" v-cloak>
        <div v-if="menuChnlEnabled">
            <el-tabs v-if="sysMenuChnls !=  null && sysMenuChnls.length > 0" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="item in sysMenuChnls" :label="item.name" :name="item.name">
                    <el-input v-if="enableSearch != null && enableSearch == true" class="mt5 mb10" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                    <el-radio-group v-if="isRadio" v-model="checkMenuId" style="display: block">
                        <el-tree class="filter-tree" :node-key="'nodeKey'" accordion :data="item.sysMenus" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode" :filter-node-method="filterNode" ref="menuTree" :render-content="renderContent"></el-tree>
                    </el-radio-group>
                    <div v-else>
                        <el-tree class="filter-tree" :node-key="'nodeKey'" accordion :data="item.sysMenus" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode" :filter-node-method="filterNode" ref="menuTree" :render-content="renderContent"></el-tree>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div v-else>
            <el-input v-if="enableSearch != null && enableSearch == true" class="mt5 mb10" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
            <el-radio-group v-if="isRadio" v-model="checkMenuId" style="display: block">
                <el-tree class="filter-tree" :node-key="'nodeKey'" accordion :data="sysMenuList" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode" :filter-node-method="filterNode" ref="menuTree" :render-content="renderContent"></el-tree>
            </el-radio-group>
            <div v-else>
                <el-tree class="filter-tree" :node-key="'nodeKey'" accordion :data="sysMenuList" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode" :filter-node-method="filterNode" ref="menuTree" :render-content="renderContent"></el-tree>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'

    import { Vue, Routes } from '../../app.vues'

    import userApi from '../../api/user'
    import servicerApi from '../../api/servicer'
    import settingApi from '../../api/setting'

    export default {
        name: 'swb-menu-tree',
        desc: '菜单树组件',
        props: {
            roleId: {
                type: Number,
                default: null
            },
            enableSearch: {
                type: Boolean,
                default: null
            },
            isRadio: {
                type: Boolean,
                default: false
            },
            scopeCode: {
                type: String,
                default: null
            },
            tplFlag: {
                type: Boolean,
                default: null
            },
            merchtTplFlag: {
                type: Boolean,
                default: null
            }
        },//departFlag 显示部门true,不显示false || null
        watch: {
            filterText: function (val) {
                this.$refs.menuTree.filter(val);
            }
        },
        data: function () {
            return {
                highlightCurrent: true,
                filterText: "",
                sysMenuList: [],
                defaultProps: {
                    children: 'sysMenuSons',
                    label: 'name'
                },
                checkMenuId: null,
                checkMenuItem: {},
                menuChnlEnabled: false,
                sysMenuChnls: [],
                activeName: null
            }
        },
        created: function () {
            let self = this;
            self.getSysMenuChnlList();
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            getSysMenuChnlList: function () {
                let self = this;
                let postData = {};
                let roleId = this.roleId;
                if(!Utils.isNoB(roleId)) {
                    postData.roleId = roleId;
                }
                if(!Utils.isNoB(self.tplFlag)) {
                    postData.tplFlag = self.tplFlag;
                }
                if(!Utils.isNoB(self.merchtTplFlag)) {
                    postData.merchtTplFlag = self.merchtTplFlag;
                }
                settingApi.getSysMenuChnlListForRole(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        if(result.code == 1) {
                            self.menuChnlEnabled = true;
                        }
                        let data = result.data[0] || {};
                        if(data != null) {
                            self.sysMenuList = data.sysMenus || [];
                            self.activeName = data.name || null;
                        }
                        self.sysMenuChnls = result.data || [];
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            filterNode: function (value, data) {
                if(!value) {
                    return true;
                }
                return data.name.indexOf(value) !== -1;
            },
            renderContent: function (createElement, node) {
                let selfTree = this;
                return createElement({
                    data: function () {
                        return {
                            item: node,
                            checkMenuId: selfTree.checkMenuId,
                            isRadio: selfTree.isRadio
                        };
                    },
                    template: '<span style=" display: inline-block; width: 100%;">' +
                    '<span v-if = "isRadio == false">' +
                    '<i v-if = "item.data.rescId == null" class="icon iconfont icon-wenjianjia catalog-icon font-gray1"></i>' +
                    '<span v-if = "item.data.rescId != null && item.data.sysResc.hiddenMenuFlag" class = "font-italic font-gray2">{{item.data.name}}</span>' +
                    '<span v-else>{{item.data.name}}</span>' +
                    '</span>' +
                    '<span v-else>' +
                    '<el-radio class = "radio" v-model="checkMenuId" :label="item.data.id">' +
                    '<i v-if = "item.data.rescId == null" class="icon iconfont icon-wenjianjia catalog-icon font-gray1"></i>' +
                    '{{item.data.name}}' +
                    '</el-radio>' +
                    '</span>' +
                    '</span>',
                    methods: {}
                });
            },
            clickNode: function (data) {
                if(this.isRadio) {
                    this.checkMenuId = data.id;
                    this.checkMenuItem.id = data.id;
                    console.log(data.id);
                    this.checkMenuItem.name = data.name;

                } else {
                    this.notityChange(data);
                }
            },
            notityChange: function (data) {
                let resultData = {};
                if(data.rescId != null) {
                    resultData.id = data.id;
                    resultData.name = data.name;
                    resultData.rescId = data.rescId;
                    this.$emit('notity-change', resultData);
                }
            },
            getDlgResult(){
                let self = this;
                let result = {};
                if(this.checkMenuId != null) {
                    result.type = 'info';
                    result.data = self.checkMenuItem;
                } else {
                    result.type = 'warn';
                    result.message = '请选择菜单';

                }
                return result;
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/SysMenuTree.vue